<template>
  <div id="app" :class="layoutDevice">
    <SiteHeader v-if="!inShell" />
    <router-view></router-view>
    <SiteFooter v-if="!inShell" />
  </div>
</template>

<script>
import SiteHeader from '@/components/SiteHeader.vue'
import SiteFooter from '@/components/SiteFooter.vue'
import { applyRootFontSize, resolveLayoutDevice } from '@/utils/device'

export default {
  components: {
    SiteHeader,
    SiteFooter,
  },
  data() {
    return {
      layoutDevice: resolveLayoutDevice(),
    }
  },
  computed: {
    inShell() {
      return this.$route.matched.some(record => record.meta.shell)
    },
  },
  created() {
    this.syncLayout()
  },
  mounted() {
    window.addEventListener('resize', this.syncLayout)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.syncLayout)
  },
  methods: {
    syncLayout() {
      this.layoutDevice = resolveLayoutDevice()
      this.$root.constructor.prototype.device = this.layoutDevice
      applyRootFontSize(this.layoutDevice)
    },
  },
}
</script>

<style>
@import url(./assets/css/reset.css);
@import url(./assets/css/site.css);
</style>
